<template>
  <Navbar />
</template>

<script>
import Navbar from "./commom/navebar/navbar.vue";

export default {
  name: "App",
  components: {
    Navbar,
  },
};
</script>

<style>
html,
body,
#app {
  min-height: 100%;
}

body {
  margin: 0;
}
</style>
